import nookies, { parseCookies } from 'nookies'
import LanguageOptions from '../utils/languages'

const defaultLanguage = { id: 'en', text: 'English' }

export const getLanguageOptions = ({ languages = ['en'] }) => {
  return LanguageOptions.filter(({ id }) => languages?.includes(id))
}

export const getDefaultLanguage = () => {
  let { selectedLanguage } = nookies.get('selectedLanguage') || defaultLanguage
  selectedLanguage =
    (selectedLanguage && JSON.parse(selectedLanguage)) || defaultLanguage
  return selectedLanguage
}

export const getLangInServerSide = ctx => {
  const cookies = parseCookies(ctx)

  const selectedLanguage = JSON.parse(cookies.selectedLanguage || '{}')
  return selectedLanguage
}
